import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonProductDetails = () => {
    return (
        <div className="container mt-4">
            <div className="row">
                {/* Left: Image Placeholder */}
                <div className="col-md-4 col-12 text-center">
                    <Skeleton height={300} width="100%" />
                    <div className="d-none d-md-flex gap-3 mt-3 flex-wrap justify-content-center">
                        <Skeleton width={120} height={50} />
                        <Skeleton width={120} height={50} />
                    </div>
                </div>

                {/* Right: Product Info Placeholder */}
                <div className="col-md-8 col-12 mt-4 mt-md-0">
                    <h5 className="mt-3 fw-bold">
                        <Skeleton width={200} />
                    </h5>

                    <div className="border p-3 rounded">
                        <p>
                            <Skeleton count={3} />
                        </p>

                        {/* Highlights Section */}
                        <div className="highlight-container">
                            {Array.from({ length: 3 }).map((_, index) => (
                                <div key={index} className="highlight-box">
                                    <Skeleton circle height={40} width={40} />
                                    <div className="highlight-label">
                                        <Skeleton width={80} />
                                    </div>
                                    <div className="highlight-value">
                                        <Skeleton width={60} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Specifications */}
                    <h4 className="mt-4">
                        <Skeleton width={150} />
                    </h4>
                    <div className="border p-3 rounded">
                        <h5>
                            <Skeleton width={120} />
                        </h5>
                        <p>
                            <strong>Imprint:</strong> <Skeleton width={100} />
                        </p>
                        <p>
                            <strong>Publication Year:</strong> <Skeleton width={80} />
                        </p>
                        <p>
                            <strong>Net Quantity:</strong> <Skeleton width={50} />
                        </p>
                    </div>
                </div>
            </div>

            {/* Bottom Buttons */}
            <div className="fixed-bottom-buttons d-md-none">
                <Skeleton width={120} height={50} />
                <Skeleton width={120} height={50} />
            </div>
        </div>
    );
};

export default SkeletonProductDetails;
